import React, { useState } from "react";
import { getImageAspectRatio } from "../utils";

const useIsImageHorizontal = (image, initState = false) => {
  const [isHorizontal, setIsHorizontal] = useState(initState);

  const aspectRatioHandler = (aspectRatio) => {
    if (aspectRatio > 1) {
      setIsHorizontal(true);
    } else {
      setIsHorizontal(false);
    }
  };

  getImageAspectRatio(image, aspectRatioHandler);

  return isHorizontal;
};

export default useIsImageHorizontal;
